import React, { useEffect, useState } from 'react';
import { graphql } from 'babel-plugin-relay/macro';
import environment from '../relayEnvironment';
import { commitMutation } from 'react-relay';
import AssessmentForm from '../components/AssessmentForm';
import copenhagenPsychosocial from '../surveys/copenhagenPsychosocial';
import { nextPage } from '../__utils__/nextPage';

const mutation = graphql`
  mutation CopenhagenPsychosocialMutation($input: PrePostMutationInput!) {
    prepostMutation(input: $input) {
      nextForm
    }
  }
`;

const CopenhagenPsychosocial = () => {
  const [formResponse, setFormResponse] = useState({});

  useEffect(() => {
    document.title = 'Wellbeing Assist - Copenhagen Psychosocial Questionnaire';
  });

  const onSubmit = (values, { setSubmitting }) => {
    const responses = Object.entries(values).map(([key, value]) => ({
      question: key,
      answer: value
    }));

    const variables = {
      input: { formName: 'CopenhagenPsychosocialForm', responses: responses }
    };

    commitMutation(environment, {
      mutation,
      variables,
      onCompleted: response => {
        setSubmitting(false);
        sessionStorage.setItem('nextForm', response.prepostMutation.nextForm);
        nextPage();
      },
      onError: ({ error }) => {
        setFormResponse({ error });
      }
    });
  };

  return (
    <AssessmentForm
      onSubmit={onSubmit}
      formResponse={formResponse}
      heading={copenhagenPsychosocial.heading}
      questions={copenhagenPsychosocial.questions}
    />
  );
};

export default CopenhagenPsychosocial;
